"use strict"

import React, { useCallback } from "react"

import { isNumber } from "../../../utils"
import { getMatchingTrend } from "../../resources/utils"
import { Dropdown, DropdownButton } from "react-bootstrap"

export default function AssignTagAxisDropdown({
  obv_info,
  graphKey,
  liveView,
  plotConfigUpdater,
  disabled = false,
  tag_category = "observations",
}) {
  const alterAxis = useCallback(
    (axisNum, tagInfo) => {
      let graph = Object.assign({}, graphKey)
      const units = [
        ...new Set(graph[tag_category].filter((series) => !series.disabled).map((obv) => obv.units)),
      ]
      let axisToggleOn = null,
        unitIndex = null

      graph[tag_category]
        .filter((obv) => getMatchingTrend(obv, tagInfo) && !obv.disabled)
        .forEach((obv) => {
          const currentAxis = obv.axis2 ? "2" : "1"
          if (currentAxis !== axisNum) {
            axisToggleOn = obv.units
            unitIndex = units.indexOf(axisToggleOn)
          }
        })

      if (axisToggleOn && isNumber(unitIndex) && units.length > 0) {
        if (units.length === 1) {
          graph[tag_category]
            .filter((obv) => !obv.disabled)
            .forEach((obv) => {
              if (getMatchingTrend(obv, tagInfo)) {
                axisNum === "1" ? delete obv.axis2 : (obv.axis2 = true)
              }
            })
          graph.axis1label = units[0]
          graph.axis2label = units[0]
        } else if (units.length === 2) {
          graph[tag_category].forEach((obs) => {
            if (axisNum === "1") {
              obs.units === axisToggleOn ? delete obs.axis2 : (obs.axis2 = true)
            } else {
              obs.units === axisToggleOn ? (obs.axis2 = true) : delete obs.axis2
            }
          })
          if (axisNum === "1") {
            graph.axis1label = units[Math.abs(parseInt(unitIndex))]
            graph.axis2label = units[Math.abs(1 - parseInt(unitIndex))]
          } else {
            graph.axis1label = units[Math.abs(1 - parseInt(unitIndex))]
            graph.axis2label = units[Math.abs(parseInt(unitIndex))]
          }
        } else {
          let axis1units = [
            ...new Set(
              graph[tag_category]
                .filter((o) => !o.disabled && !o.axis2 && o.units !== axisToggleOn)
                .map((o) => o.units),
            ),
          ]
          let axis2units = [
            ...new Set(
              graph[tag_category]
                .filter((o) => !o.disabled && o.axis2 && o.units !== axisToggleOn)
                .map((o) => o.units),
            ),
          ]
          graph[tag_category]
            .filter((obs) => obs.units === axisToggleOn)
            .forEach((obs) => {
              axisNum === "1" ? delete obs.axis2 : (obs.axis2 = true)
            })

          axisNum === "1" ? axis1units.push(axisToggleOn) : axis2units.push(axisToggleOn)
          graph.axis1label = axis1units.join(" / ")
          graph.axis2label = axis2units.join(" / ")
        }

        let axis1units = [
          ...new Set(graph[tag_category].filter((o) => !o.disabled && !o.axis2).map((o) => o.units)),
        ]
        let axis2units = [
          ...new Set(graph[tag_category].filter((o) => !o.disabled && o.axis2).map((o) => o.units)),
        ]

        if (!liveView) {
          if (axis2units.length === 0) {
            delete graph.outlierFilter2
            delete graph.axis2domain
            delete graph.axis2label
          }

          if (axis1units.length === 0) {
            delete graph.outlierFilter
            delete graph.axis1domain
            delete graph.axis1label
          }
        }

        plotConfigUpdater(graph)
      }
    },
    [graphKey, liveView, plotConfigUpdater, tag_category],
  )
  return (
    <>
      <DropdownButton
        title={obv_info.axis2 ? "Y2" : "Y1"}
        className={"select-option local-btn-sm"}
        variant={"outline-primary"}
        size={"sm"}
        disabled={obv_info.disabled || disabled}
      >
        {["Y1", "Y2"].map((opt) => (
          <Dropdown.Item
            key={opt}
            name={opt}
            onClick={(ev) => {
              ev.preventDefault()
              if (opt === "Y1") {
                alterAxis("1", obv_info)
              } else {
                alterAxis("2", obv_info)
              }
            }}
          >
            {opt}
          </Dropdown.Item>
        ))}
      </DropdownButton>
    </>
  )
}
